import React, { useEffect, useState, useRef } from "react";
import { useHistory, withRouter, Link } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import {
    WebUrl,
    ApiUrl,
    ApiKey,
} from "../../util/Constant";
import { useTranslation } from "react-i18next";
import Input from "../../components/custom/Input";
import ApiEngine from "../../util/ApiEngine.js";
import {
    setBusy,
    setIdle,
    showResponseMessage,
    showMessage,
    setRegisterModal
} from "../../redux/AppAction.js";
import { Modal, ModalBody, ModalHeader, ModalFooter } from "reactstrap";
import CreateAnAccountDesktop from "components/desktop/CreateAnAccount";
import { set } from "lodash";

const RegisterCode = (props) => {
    var { t, i18n } = useTranslation();
    var _dispatch = useDispatch();
    var _history = useHistory();
    const registerModal = useSelector((state)=>state.appState.registerModal)
    const [referralCode, setReferralCode] = useState("");
    const [showCodeError, setShowCodeError] = useState(false);
    const [isReferralCode, setIsReferralCode] = useState(true);
    const [isCreateAnAccount, setIsCreateAnAccount] = useState(false);

    async function checkIfReferralExist(code) {
        let referralCode = code;
        if (code.includes(" +")) {
            referralCode = code.substring(0, code.indexOf(" +"));
        }
        let apiUrl =
            ApiUrl._API_CHECK_IF_REFERRAL_CODE_EXIST + "?code=" + referralCode;
        let responseJson = await ApiEngine.get(apiUrl);
        if (responseJson[ApiKey._API_SUCCESS_KEY]) {
            setIsReferralCode(false);
            setIsCreateAnAccount(true);
        } else {
            _dispatch(
                showResponseMessage(
                    responseJson[ApiKey._API_SUCCESS_KEY],
                    t(responseJson[ApiKey._API_MESSAGE_KEY])
                )
            );
        }
    }

    const validateReferralCode = (e) => {
        var regexp = /^[A-Za-z0-9]+$/i;
        if (e.nativeEvent.data === null || regexp.test(e.nativeEvent.data)) {
            setReferralCode(e.target.value);
        }
    };

    return (
        <>
            {/* ////register modal */}
            <Modal
                id="login-register-modal"
                fade={false}
                contentClassName={"login-register-modal"}
                isOpen={registerModal}
                toggle={() => {
                    _dispatch(setRegisterModal(false))
                    setIsReferralCode(true);
                    setIsCreateAnAccount(false);
                }}
                // backdrop={'static'}
                centered
            >
                <ModalBody>
                    <div className="login-register-container">
                        <div className="login-register-header">
                            <div className="modal-logo">
                                <img
                                    src={
                                        require("../../assets/img/logobig2.png")
                                    }
                                    className="img-responsive"
                                    style={{ height: "40px" }}
                                    alt="logo"
                                    loading="lazy"
                                />
                            </div>
                            <div onClick={() => {_dispatch(setRegisterModal(false));}}>
                                <svg
                                    className="cursor-pointer"
                                    viewBox="0 0 1024 1024"
                                    width="20px"
                                    height="20px"
                                    style={{ display: "inline-block", stroke: "currentColor", fill: "currentColor" }}
                                    >
                                    <path d="M512 439.603l-362.035-362.035-72.397 72.397 362.035 362.035-362.035 362.035 72.397 72.397 362.035-362.035 362.035 362.035 72.397-72.397-362.035-362.035 362.035-362.035-72.397-72.397-362.035 362.035z"></path>
                                </svg>
                            </div>
                        </div>
                        <div className="login-register-body">
                            <div className="left">
                                    <img
                                    src={
                                        require("../../assets/img/desktop/modal-image.png")
                                    }
                                    className="img-responsive"
                                    alt="okup"
                                    loading="lazy"
                                />
                            </div>
                            <div className="right">
                                <div className="w-100">
                                    {isReferralCode && (
                                        <>
                                            <h3 className="mt-2 mb-4 text-center">
                                                {t("ENTER_YOUR_REFERRAL_CODE")}
                                            </h3>
                                            <div className="margin-bottom-0 custom-form text-left">
                                                <div className="password-with-eye">
                                                    <Input
                                                        id="referral"
                                                        name="referral"
                                                        onInput={(e) => validateReferralCode(e)}
                                                        label={t("KEY_IN_YOUR_REFERRAL_CODE")}
                                                        placeholder={t("INPUT_REFERRAL_CODE")}
                                                        value={referralCode}
                                                        autoFocus
                                                    />
                                                </div>
                                                {showCodeError && (
                                                    <div className="d-flex align-items-center user-available mb-4">
                                                        <div className="font12 text-lgray3 second text-customred">
                                                            {t("INVALID_REFERRAL_CODE")}
                                                        </div>
                                                    </div>
                                                )}
                                                <button
                                                    className="btn btn-custom font20 mt-4"
                                                    onClick={() => {
                                                        if (referralCode.length >= 8) {
                                                            setShowCodeError(false);
                                                            checkIfReferralExist(referralCode);
                                                        } else {
                                                            setShowCodeError(true);
                                                        }
                                                    }}
                                                >
                                                    {t("VERIFY_CODE")}
                                                </button>
                                            </div>
                                            <div
                                                onClick={() => {
                                                    _history.push(WebUrl._URL_LIVECHAT);
                                                    _dispatch(setRegisterModal(false));
                                                }}
                                                style={{ cursor: "pointer" }}
                                            >
                                                <p className="f-weight-500 font16 mt-4 text-lblue1 text-underline text-center">
                                                    {t("DONT_HAVE_CODE_CLICK_HERE_FOR_LIVE_CHAT")}
                                                </p>
                                            </div>
                                        </>
                                    )}
                                    {isCreateAnAccount && (
                                        <CreateAnAccountDesktop
                                            code={referralCode}
                                        />
                                    )}
                                </div>
                            </div>
                        </div>
                    </div>
                </ModalBody>
            </Modal>
        </>
    );
};

export default withRouter(RegisterCode);
